import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { LocalStorageService } from './local-storage.service';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RouteGuardService {
  private hasCheckedInitialRoute = false;

  constructor(
    private router: Router,
    private localStorageService: LocalStorageService
  ) {
    // Listen to navigation events to check routes
    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => {
        console.log('=== ROUTE NAVIGATION ===');
        console.log('Navigation to:', event.url);
        this.handleRouteNavigation(event.url);
      });
  }

  private handleRouteNavigation(url: string): void {
    console.log('=== ROUTE GUARD CHECK ===');
    console.log('Current URL:', url);
    console.log('Has checked initial route:', this.hasCheckedInitialRoute);

    // Only check once per session to avoid infinite loops
    if (this.hasCheckedInitialRoute) {
      console.log('Already checked initial route, skipping');
      return;
    }

    this.hasCheckedInitialRoute = true;

    // Don't redirect if we're already on a financial route
    if (url.startsWith('/financial')) {
      console.log('Financial route detected, no redirect needed');
      return;
    }

    // Check for pending payment (user might have closed app after VPN disconnect)
    if (this.localStorageService.hasPendingPayment()) {
      const pendingPayment = this.localStorageService.getPendingPayment();
      console.log('Pending payment detected:', pendingPayment);
      console.log('Redirecting to checkout...');
      this.router.navigateByUrl('/financial/checkout', { replaceUrl: true });
      return;
    }

    // Redirect to quiz if on root
    if (url === '/' || url === '') {
      console.log('Root route detected, redirecting to quiz...');
      this.router.navigateByUrl('/quiz', { replaceUrl: true });
    }
  }
}
